import {Component, Input, OnInit} from '@angular/core';
import {Pagination} from "@core/bean/pagination";
import {BrowseConfig} from "@core/bean/browse-config";
import {HttpParams} from "@angular/common/http";
import {CommonsService} from "@core/service/commons.service";
import {Observable} from "rxjs/index";
import {NzModalService} from "ng-zorro-antd";
import {PurchaseOrderDetailService} from "../../../../routes/jy-srm/order/purchase-order/purchase-order-detail.service";
import {Direction} from "@core/bean/direction";
import {Sort} from "@core/bean/sort";

@Component({
  selector: 'app-purchase-order-line',
  templateUrl: './purchase-order-line.component.html',
  styles: []
})
export class PurchaseOrderLineComponent implements OnInit {
  static componentName = 'PurchaseOrderLineComponent';
  @Input() config:BrowseConfig;
  @Input() onOk:(data:any | [any]) => void;
  @Input() onCancel:() => void;

  visible = false;
  formLoading = false;
  pagination:Pagination = new Pagination();
  searchData:any = {};
  constructor(private commonsService:CommonsService,
              private modalService:NzModalService,
              private purchaseOrderDetailService:PurchaseOrderDetailService
  ) {
    this.pagination.getData = function (params:HttpParams):Observable<any> {
      return purchaseOrderDetailService.query(params);
    }
  }


  ngOnInit() {
    this.pagination.addInitSort(new Sort("createdDate", Direction.DESC));
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  selectData(data){
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }

}
